export const CUSTOMER_TYPE = {
    INDIVIDUAL: { value: 0, name: '個人消費者'},
    CORPORATE: { value: 1, name: '法人消費者'},
    DEALER: { value: 2, name: '販売店'},
    BRANCH: { value: 3, name: '支店'},
    OTHER: { value: 4, name: 'その他'},
}

export const GENDER_TYPE = {
    MEN: { value: 0, name: '男'},
    WOMEN: { value: 1, name: '女'},
    OTHER: { value: 2, name: 'その他'},
}

export const getCustomerTypeName = (customerTypeId) => {
    const customerType = Object.values(CUSTOMER_TYPE).find(item => item.value === customerTypeId)
    if (!customerType) return ''
    return customerType.name
}

export const getGenderName = (genderId) => {
    const gender = Object.values(GENDER_TYPE).find(item => item.value === genderId)
    if (!gender) return ''
    return gender.name
}